import moment from 'moment-timezone';
import { isObee } from '../utils/constants';
import { safeParse } from '../utils/stringHelpers';

// Venues set up with the wrong slug, mapped to the slug they should use on ECB
const slugCorrections = {
  obeecom_the_depot: 'thedepot',
};

export const migrationRedirectMiddleware = () => (next) => (action) => {
  if (isObee && action.type === 'RESTAURANT_FOR_SLUG_SUCCESS' && action.payload.data) {
    const ecbWidgetUrl = process.env.REACT_APP_ECB_WIDGET_URL;
    const parsed = safeParse(action.payload.data?.bookingWidgetSettings);
    const { migrated, migratedDate } = parsed || {};
    const migratedMoment = moment(migratedDate);

    if (
      migrated &&
      migratedDate &&
      ecbWidgetUrl &&
      migratedMoment.isValid() &&
      moment().isAfter(migratedMoment)
    ) {
      const slug = action.payload.data?.slug;
      const ecbSlug = slugCorrections[slug] || slug;
      window.location.href = `${ecbWidgetUrl.replace(/\/$/, '')}/${ecbSlug}${
        window.location.search
      }`;
      return;
    }
  }

  next(action);
};
